import styled, { css } from 'styled-components'

export const styleReset = css`
  appearance: none;
  padding: 0;
  margin: 0;
  border: none;
  font: inherit;
  text-align: inherit;
  color: inherit;
  background: none;
`

export const Overlay = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

export const YouTube = styled.iframe`
  display: block;
  width: 100%;
  height: auto;
  margin-block: 1.4em;
  aspect-ratio: 16 / 9;
`
